import { render, staticRenderFns } from "./BatteryProjects.vue?vue&type=template&id=319db7ca"
import script from "./BatteryProjects.vue?vue&type=script&lang=js"
export * from "./BatteryProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports